<script lang="ts">
	import * as Breadcrumb from '$lib/components/ui/breadcrumb/index.js';
	import type { ListingBreadcrumbItem } from '$lib/utils/listing-seo';
	import { localizeHref } from '@/paraglide/runtime';

	let { items = [] }: { items?: ListingBreadcrumbItem[] } = $props();
</script>

{#if items.length > 0}
	<nav aria-label="Breadcrumb" class="px-4 pt-4 md:px-0 md:pt-6">
		<Breadcrumb.Root>
			<Breadcrumb.List class="flex-wrap gap-1 text-xs text-gray-600 md:text-sm">
				{#each items as item, index (index)}
					<div class={item.href ? 'contents' : 'hidden md:contents'}>
						{#if index > 0}
							<Breadcrumb.Separator />
						{/if}
						<Breadcrumb.Item>
							{#if item.href}
								<Breadcrumb.Link
									href={localizeHref(item.href)}
									class="max-w-40 truncate md:max-w-none"
								>
									{item.name}
								</Breadcrumb.Link>
							{:else}
								<Breadcrumb.Page class="max-w-48 truncate font-medium text-gray-900 md:max-w-md">
									{item.name}
								</Breadcrumb.Page>
							{/if}
						</Breadcrumb.Item>
					</div>
				{/each}
			</Breadcrumb.List>
		</Breadcrumb.Root>
	</nav>
{/if}
